import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Home, ArrowForwardIos } from '@mui/icons-material';
import common from '~/common';
import DataList from '~/containers/Page_Main/TreeList/DataList';

class PageLabel extends React.Component {
  _click_Home=() => {
    const { history } = this.props;
    history.push(`${common.rootPath}/Manage/Main`);
  }

  _click_Re=() => {
    const { history } = this.props;
    const path = history.location.pathname;
    history.push(`${common.rootPath}/Manage/Main`);
    const timer = setInterval(() => {
      history.push(path);
      clearInterval(timer);
    }, 50);
  }

  render () {
    const { history, pageText = '' } = this.props;
    let path = `${history.location.pathname.substring(1)}/`;
    const pathAry = [];
    const havePageText = pageText.length > 0;
    while (path.match('/')) {
      const newT = path.substring(0, path.indexOf('/'));
      if (newT.length > 0)pathAry.push(newT);
      path = path.substring(path.indexOf('/') + 1);
    }
    pathAry.splice(0, 1);
    const returnSPathIcon = () => {
      const isCurrent = pathAry.length === 3 && !havePageText;
      if (pathAry.length > 2) {
        for (let i1 = 0; i1 < DataList.length; i1++) {
          for (let i2 = 0; i2 < DataList[i1].detail.length; i2++) {
            if (pathAry[2] === DataList[i1].detail[i2].path) {
              const Icon = DataList[i1].detail[i2].icon;
              return <Icon style={{ height: 24, width: 24, marginRight: 4, color: isCurrent ? '#064B6F' : 'white', cursor: DataList[i1].detail[i2].page ? 'pointer' : 'default' }} onClick={DataList[i1].detail[i2].page ? this._click_Re : null} />;
            }
          }
        }
      }
    };

    const returnSPathText = () => {
      const isCurrent = pathAry.length === 3 && !havePageText;
      if (pathAry.length > 2) {
        for (let i1 = 0; i1 < DataList.length; i1++) {
          for (let i2 = 0; i2 < DataList[i1].detail.length; i2++) {
            if (pathAry[2] === DataList[i1].detail[i2].path) return <div style={{ color: isCurrent ? '#064B6F' : 'white', cursor: DataList[i1].detail[i2].page ? 'pointer' : 'default' }} onClick={DataList[i1].detail[i2].page ? this._click_Re : null}>{DataList[i1].detail[i2].text}</div>;
          }
        }
      }
    };

    const returnTPathText = () => {
      const isCurrent = pathAry.length === 4 && !havePageText;
      if (pathAry.length > 3) {
        for (let i1 = 0; i1 < DataList.length; i1++) {
          for (let i2 = 0; i2 < DataList[i1].detail.length; i2++) {
            for (let i3 = 0; i3 < DataList[i1].detail[i2].detail.length; i3++) {
              if (pathAry[3] === DataList[i1].detail[i2].detail[i3].path) {
                return <div style={{ color: isCurrent ? '#064B6F' : 'white', cursor: 'pointer' }} onClick={this._click_Re}>{DataList[i1].detail[i2].detail[i3].text}</div>;
              }
            }
          }
        }
      }
    };

    return (
      <div style={{ height: 32, marginRight: 26, display: 'flex', flexDirection: 'row-reverse' }}>
        <div style={{ height: 32, backgroundColor: '#B2D6DB', borderRadius: '0px 0px 8px 8px', display: 'flex', alignItems: 'center', paddingRight: 12, paddingLeft: 12 }}>
          <Home style={{ height: 24, width: 24, marginRight: 4, color: pathAry.length === 1 ? '#064B6F' : 'white', cursor: 'pointer' }} onClick={this._click_Home} />
          <div style={{ color: pathAry.length === 1 ? '#064B6F' : 'white', cursor: 'pointer' }} onClick={this._click_Home}>首頁</div>
          {pathAry.length > 2 && <ArrowForwardIos style={{ height: 16, width: 16, marginRight: 8, marginLeft: 8, color: 'white' }} />}
          {returnSPathIcon()}
          {returnSPathText()}
          {pathAry.length > 3 && <ArrowForwardIos style={{ height: 16, width: 16, marginRight: 8, marginLeft: 8, color: 'white' }} />}
          {returnTPathText()}
          {havePageText && <ArrowForwardIos style={{ height: 16, width: 16, marginRight: 8, marginLeft: 8, color: 'white' }} />}
          {havePageText && <div style={{ color: '#064B6F' }}>{pageText}</div>}
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  pageText: state.data.PageText,
});

export default withRouter(connect(mapStateToProps, null)(PageLabel));
